@if (showStatusBar()) {
    <div class="flex flex-col py-medpace-field gap-medpace-field items-end">
        @if (hiddenRequiredColIds().length === 1) {
            <div>
                Column <span class="font-bold">{{ hiddenRequiredColIds()[0] }}</span> is required to add a new expense.
                Please display this column to proceed.
            </div>
        } @else if (hiddenRequiredColIds().length > 1) {
            <div>
                Columns <span class="font-bold">{{ hiddenRequiredColIds().join(', ') }}</span> are required to add a new
                expense. Please display these columns to proceed.
            </div>
        }
        @if (isSumVisible()) {
            <div>Sum: {{ sum() | number: '1.2-2' }}</div>
        }
    </div>
}
